import React, { Component } from "react";
import { Paper } from "@material-ui/core";
import { connect } from "react-redux";
import {
  getNewPurchaseFundList,
  getFundWiseEarnings,
} from "../../../store/actions";
import CustomLoading from "../CustomLoader";
import { FormatCurrency } from "../currencyFormatter";
import CustomLoader from "../../forms/Loader";

export const MyEarnings_URL = `/my-earnings`;

class MyEarnings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFund: 0,
    };
  }
  async componentDidMount() {
    this.getEarnings("189");
  }

  getEarnings = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    const params = {
      ReqBy: "M",
      Agent: this.props.token,
      Fund: "189",
      customfund: "189",
    };
    this.props.getFundWiseEarnings(params);
  };

  get total() {
    const { earnings = [] } = this.props;
    return earnings.reduce((prev, curr) => prev + curr.Amount, 0);
  }

  render() {
    const { fundsList = [], earnings = [], count } = this.props;
    const { selectedFund } = this.state;
    return (
      <div style={{ margin: "20px 30px 100px 30px" }}>
        <div className="investor-title">My Earnings</div>
        {count > 0 && !fundsList.length ? (
          <CustomLoader
            display={count > 0 && !fundsList.length ? true : false}
          />
        ) : (
          <Paper
            className="digital-form-container"
            style={{ boxShadow: "0px 0px 2px 0px lightgray", margin: 0 }}
          >
            {/* <div className="digital-form-left-div">
              {fundsList.map((fund, index) => (
                <div
                  key={index}
                  className="digital-form-investor-list"
                  style={{
                    backgroundColor:
                      index === selectedFund ? "#f3f9fd" : "#FFF",
                    cursor: "pointer"
                  }}
                  onClick={() => this.getEarnings(fund.amc_code, index)}
                >
                  <div
                    className={
                      index === selectedFund ? "digital-form-main-text" : ""
                    }
                  >
                    {fund.amc_name}
                  </div>
                </div>
              ))}
            </div> */}
            <div className="digital-form-Right-div" style={{ borderLeft: 0 }}>
              <div className="Brokerage-details-responsive">
                <div
                  style={{
                    fontSize: 16,
                    marginBottom: 20,
                    color: "#053c72",
                  }}
                >
                  Brokerage Details{" "}
                  <span
                    style={{
                      marginLeft: 10,
                      fontSize: 17,
                    }}
                  >
                    (last 6 months)
                  </span>
                </div>
                <div className="earnings-total">
                  Total: <FormatCurrency value={this.total} />
                </div>
              </div>

              {count > 0 ? (
                <CustomLoading type="ThreeDots" height={60} width={60} />
              ) : earnings.length ? (
                earnings.map((earning, index) => (
                  <div key={index} style={{ marginBottom: 10, marginTop: 10 }}>
                    <div className="earnings-bankname">{earning.BankName}</div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 15,
                        marginBottom: 20,
                      }}
                    >
                      <div>
                        <div
                          style={{
                            color: "#555555",
                            fontSize: 14,
                          }}
                        >
                          Period:
                        </div>
                        <div
                          style={{
                            fontSize: 15,
                            marginTop: 4,
                          }}
                        >
                          {earning.Fromdate} to {earning.ToDate}
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: 13,
                          }}
                        >
                          Amount
                        </div>
                        <div
                          style={{
                            fontSize: 15,
                            marginTop: 4,
                            padding: "2px 15px 2px 5px",
                          }}
                        >
                          <FormatCurrency value={earning.Amount} />
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        borderBottom: "1px solid  #AAAAAA",
                        marginTop: 10,
                      }}
                    />
                  </div>
                ))
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    color: "red",
                  }}
                >
                  No Data Found
                </div>
              )}
            </div>
          </Paper>
        )}
        {/* <div
          style={{
            fontSize: 14,
            fontFamily: "Rubik-Bold",
            marginBottom: 130,
            textAlign: "center",
            marginTop: 15,
          }}
        >
          FOR ADDITIONAL BROKERAGE DETAILS, KINDLY EMAIL AT:{" "}
          <span>
            <a
              style={{ color: "#005DAC" }}
              href="mailto:brokerage@miraeasset.com"
            >
              brokerage@miraeasset.com
            </a>
          </span>
        </div> */}
      </div>
    );
  }
}

export default connect(
  ({ transactions, authReducer, loading }) => {
    const { fundsList, earnings } = transactions;
    const { token } = authReducer;
    const { count } = loading;
    return { fundsList, token, earnings, count };
  },
  { getNewPurchaseFundList, getFundWiseEarnings }
)(MyEarnings);
